<template>
  <el-dialog
    class="main-dialog"
    :title="undefined"
    :show-close="false"
    :visible="visible"
    :width="isDesktop ? '60%' : '90%'"
    :before-close="onCloseSettings">
    <div class="el-dialog__content" style="max-width:930px;margin-left:auto;margin-right:auto;text-align:center;">
      <h1 style="padding-bottom:1em;color:black;">COVID-19 STATEMENT</h1>
      <div style="text-align:left;padding-left:30px;padding-right:30px;">
        <span style="word-break:break-word">
          Thanks for stopping by the BOSS!  We are eager to host the 15th Annual Boss Hog Cook-Off (BHC); however, we understand that we are living in uncertain times.  The health and safety of our community, teams, judges, and volunteers remain our top priority; therefore, we are closely monitoring the ever-changing news and spread of COVID-19, and will make decisions and update as needed…  Check our social media (Facebook &amp; Instagram) for any and all updates.
        </span>
      </div>
      <div style="text-align:left;padding-left:30px;padding-right:30px;margin-top:15px;">
        <span style="word-break:break-word">
          Our desire is to bring back this community favored event, even with mask-covered smiles, air hugs, and air high-fives.  Hope to see you at the BOSS in Waynesboro, GA on May 14th &amp; 15th!
        </span>
      </div>
      <!-- <div style="text-align:left;padding-left:30px;padding-right:30px;">
        <span style="word-break:break-word">
          With President Trump extending the federal social distancing guidelines through April 30th, we have concluded that we must go ahead and make a final call on our 15th Annual Boss Hog State Championship event scheduled for May 8th &amp; 9th.
        </span>
      </div>
      <div style="text-align:left;padding-left:30px;padding-right:30px;margin-top:15px;">
        <span style="word-break:break-word">
          As we have closely monitored the ever-changing news regarding the Coronavirus (COVID-19) Pandemic, we feel it is in everyone’s best interest and our responsibility to do our part and cancel this year’s event. <b>The 15th Annual Boss Hog State Championship Cook-Off will NOW be held next year on May 14-15, {{year}}</b>.
        </span>
      </div>
      <div style="text-align:left;padding-left:30px;padding-right:30px;margin-top:15px;">
        <span style="word-break:break-word">
          We understand the concerns regarding the Coronavirus (COVID-19) Pandemic, so we are offering all of our teams, sponsors, AND vendors the option to be refunded fully OR to apply the payment to next year’s event (scheduled for {{date}}).  However, if you choose to be refunded, you must let us know no later than Thursday, April 30, 2020, in order to receive your refund.  If we haven’t heard from you by then, we will apply your funds to our {{year}} Competition.  We appreciate your support and understanding.  If you have any questions, please don’t hesitate to email us @ <a href="mailto:bosshogcookoff@yahoo.com" target="_blank">bosshogcookoff@yahoo.com</a> !
        </span>
      </div>
      <div style="text-align:left;padding-left:30px;padding-right:30px;margin-top:15px;">
        <span style="word-break:break-word">
          We hope to see you at the 15th Annual Boss Hog State Championship Cook-Off on {{date}}, in Waynesboro, GA!  Stay safe!
        </span>
      </div> -->
      <div style="text-align:left;padding-left:30px;padding-right:30px;margin-top:15px;">
        <span style="word-break:break-word">
          Your BHC Crew,<br />
          Lindsey Beazley Keller, Nan Palmer Lynch, Elizabeth Billips, &amp; Tim Lively
        </span>
      </div>
      <!-- <div style="text-align:left;padding-left:30px;padding-right:30px;">
        <span style="word-break:break-word">
          We understand that you may have some concerns regarding the Coronavirus (COVID-19) Pandemic, as do we…  We are closely monitoring the ever-changing updates and praying for this crisis to be better in time for the 15th Annual Boss Hog State Championship Cook-Off on May 8th & 9th; however, if we do have to cancel this year’s Boss Hog Cook-Off event then we are offering all of our teams AND sponsors the option to be refunded fully OR to apply the payment to next year’s event (scheduled for {{date}}).  Although this is not the case yet, we will be making the final decision on April 14th.  If you have any questions, please don’t hesitate to email us @ <a href="mailto:bosshogcookoff@yahoo.com" target="_blank">bosshogcookoff@yahoo.com</a> !
        </span>
      </div>
      <div style="text-align:left;padding-left:30px;padding-right:30px;margin-top:15px;">
        <span style="word-break:break-word">
          Thank you for your interest and support of the BOSS!  We hope to see you at the 15th Annual Boss Hog State Championship Cook-Off on May 8-9, 2020, in Waynesboro, GA!
        </span>
      </div>
      <div style="text-align:left;padding-left:30px;padding-right:30px;margin-top:15px;">
        <span style="word-break:break-word">
          Thank you,<br /><br />
          Your BHC Gals: “NANSEYBETH”<br />
          (Nan Palmer Lynch, Lindsey Beazley Keller, &amp; Elizabeth Billips)
        </span>
      </div> -->
    </div>
    <span slot="footer" class="dialog-footer" align="center">
      <!-- <el-button type="primary" @click="onClose">Ok</el-button> -->
      <div class="button is-primary" style="margin-bottom:15px;margin-right:-10px;" @click="onClose">
        <span style="text-transform:uppercase;">Close</span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import EventBus from '@/controllers/EventBus'
export default {
  name: 'MainDialog',
  props: ['visible'],
  data () {
    return {
      isDesktop: true
    }
  },
  computed: {
    year: function () {
      return EventBus.info.year
    },
    date: function () {
      return EventBus.info.date
    }
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.main-dialog {
  .el-dialog__footer {
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// MainDialog.vue?5a9c7da8